/* template */
<template><div class="hot-city-main"><div :style='["height:22px"] | transRpxStyle'></div><div class="city-title">{{title}}</div><div class="city-container"><mpx-view v-for="(item, index) in (list)" :key="item.index" :class="({active:item.isChoosed})" @tap="handleClick(item)" class="city-container-item">{{ item.city_name }}</mpx-view></div></div></template>

/* styles */
<style scoped lang="stylus" mpxStyleOptions='{"mid":"mc357207e"}'>
  .hot-city-main
    margin-left 17px
    margin-right 14px
    font-size 14px
    font-weight normal
    color #333333
    font-family PingFangSC-Semibold
  .city-container
    margin-top 12px
    display grid
    grid-gap 8px
    grid-template-columns: repeat(3, 1fr)
    justify-items center 
    align-items center
    &-item
      width 100%
      height 36px
      box-sizing border-box
      line-height 36px
      background #F6F7F8
      border-radius 8px
      text-align center
      font-size 14px
      font-weight 400
      color #000000
      font-family Ping Fang SC
      &.active
        background #FFFFFF
        border 1px solid #FF6400
        position relative
        &:after
          content ''
          position absolute
          width 18px
          height 14px
          right -1px
          bottom -1px
          background-image url('https://dpubstatic.udache.com/static/dpubimg/sJ9KdDopDQpQoKQX0zqOD.png')
          background-size 100% 100%
    &:after
      content ''
      width 99px
      max-width 30%
      border 1px solid transparent
  .city-item
    height 35px
    line-height 35px
    background #FCFCFD
    border 1px solid #E5E5E5
    border-radius 8px
    text-align center
</style>

/* json */
/* script */
<script>
  import processOption, { getComponent, getWxsMixin } from "@mpxjs/webpack-plugin/lib/runtime/optionProcessor"
  const wxsModules = {}
  global.currentModuleId = "mc357207e"
  global.currentSrcMode = "wx"
  /** script content **/
  require("./city-label.mpx.js?isComponent&outputPath=components%2Fcity-labelc357207e%2Findex!=!@mpxjs/webpack-plugin/lib/selector?mode=web&env=!./city-label.mpx?ctorType=component&index=0&isComponent&mpx&outputPath=components%2Fcity-labelc357207e%2Findex&type=script")
  const currentOption = global.__mpxOptionsMap["mc357207e"]
  export default processOption(
    currentOption,
    "component",
    "",
    "components/city-labelc357207e/index",
    {},
    // @ts-ignore
    {},
    // @ts-ignore
    {'es-icon':getComponent(require("../../../../node_modules/@didi/es-mpx-ui/lib/icon/index.mpx?isComponent&outputPath=components%2Findex6fe48a3a%2Findex")),'mpx-view':getComponent(require("@mpxjs/webpack-plugin/lib/runtime/components/web/mpx-view.vue?isComponent"), { __mpxBuiltIn: true })},
    undefined,
    {},
    undefined,
    getWxsMixin(wxsModules)
  )
</script>
